export default {
  ELIXIO_CONNECT: {
    // --- General ---
    ACCOUNTS: 'Accounts',
    VIEW_ELIXIO_CONNECT: 'Synchronization',
    SOMETHING_WENT_WRONG: 'Something went wrong',
    OPERATION_SUCCEEDED: 'Operation succeeded',
    OPERATION_FAILED: 'Operation failed',
    CONFIRMATION: 'Confirmation',
    YES: 'Yes',
    NO: 'No',
    OK: 'OK',
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    CLOSE: 'Close',
    SEARCH: 'Search',
    PER_PAGE: 'Per Page',
    STATUS: 'Status',
    ALL_STATUSES: 'All statuses',
    ALL: 'All',
    NONE: 'None',
    NAME: 'Name',
    EMAIL: 'Email',
    DATE: 'Date',
    TYPE: 'Type',
    DETAILS: 'Details',
    VIEW: 'View',
    EDIT: 'Edit',
    DELETE: 'Delete',
    UPDATE: 'Update',
    CREATED_AT: 'Created on',
    UPDATED_AT: 'Updated on',
    DATE_FROM: 'From',
    DATE_TO: 'To',
    CREATED_BY: 'Created by',
    UPDATED_BY: 'Updated by',
    DISPLAY_FROM_X_TO_X_OF_X_ENTRIES: 'Displaying from {from} to {to} on {of} entries',
    X_LINES_SELECTED: '{count} lines selected',
    ERROR: 'Error',

    // --- Services / Modules ---
    ADD_ELIXIO_CONNECT_SERVICE: 'Add a service',
    ADD_ELIXIO_CONNECT_CONFIGURE_THIS_SERVICE: 'Configure',
    ELIXIO_CONNECT_SUBMIT: 'Submit',
    ELIXIO_CONNECT_TEST_CONFIG: 'Test Configurations',
    ELIXIO_CONNECT_PROD_CONFIG: 'Production Configurations',
    ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION: 'Confirm this action?',
    ELIXIO_ADDITIONNAL_CONFIG_TITLE: 'Additional Configuration',
    ELIXIO_START_CONNECT: 'Start',
    ELIXIO_PENDING_CONNECT: 'Update in progress...',
    ELIXIO_STOP_CONNECT: 'Stop',
    ELIXIO_TAB_DATA_TITLE: 'Synchronize existing data',
    ELIXIO_TAB_CONFIG: 'Configuration',
    ELIXIO_TAB_UPDATE_DATA: 'Synchronize existing data',
    ELIXIO_CONNECT_STATUS_PENDING: 'In progress',
    ELIXIO_CONNECT_STATUS_DONE: 'Completed',
    ELIXIO_UPDATED_INVOICES: 'Synchronizing invoices',
    ELIXIO_UPDATED_PAYMENTS: 'Synchronizing payments',
    ELIXIO_UPDATED_CUSTOMERS: 'Synchronizing customers',
    ELIXIO_CONNECT_COMPLETED: 'Synchronization completed',
    ELIXIO_CONNECT_CANCELLED: 'Synchronization canceled',
    ELIXIO_CONNECT_TOTAL_PROGRESS: 'Total progress',
    ELIXIO_START_IMPORT_AT: 'Start from:',
    SELECT_DATE: 'Select a date',
    ELIXIO_CONNECT_CONFIRM_THIS_DEACTIVATION: 'Confirm this deactivation?',
    ELIXIO_CONNECT_CONFIRM_THIS_REACTIVATION: 'Confirm this reactivation?',
    LOGIN_TO_YOUR_ACCOUNT: 'Log in to your account',
    MODULES: 'Available modules',
    LOGIN_TO: 'Log in to',
    RE_LOGIN_TO: 'Re-log in to',
    DEACTIVATE: 'Deactivate',
    ACTIVATE: 'Activate',
    REACTIVATE: 'Reactivate',
    VALIDATE: 'Validate',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    DEACTIVATED: 'Deactivated',
    CONFIGURE: 'Configure',
    AUTH_FINISHED: 'Authentication finished. Refreshing...',
    NOT_CONFIGURED_YET: 'Not yet configured',
    SUB_SERVICES: 'Available services',
    NO_SUB_SERVICES: 'No available services',
    SHOW_SUB_SERVICES: 'Show services',
    HIDE_SUB_SERVICES: 'Hide services',
    PARENT_AUTO_ACTIVATED: 'ElixioPay has been activated automatically',
    PARENT_AUTO_DEACTIVATED: 'ElixioPay has been deactivated automatically',
    SEARCH_SERVICES: 'Search services...',
    SERVICES: 'services',
    NO_RESULTS: 'No results found',
    LANGUAGE: 'Language',
    TIMEZONE: 'Timezone',

    // --- GHL Import ---
    GHL_IMPORT_CONTACTS_TAB: 'Import Contacts',
    GHL_IMPORT_TITLE: 'Import contacts from GoHighLevel',
    GHL_IMPORT_START: 'Start Import',
    GHL_IMPORT_CONFIRM: 'This will import all contacts from your GoHighLevel account. Continue?',
    GHL_IMPORT_IN_PROGRESS: 'Import in progress...',
    GHL_IMPORT_CREATED: 'Created',
    GHL_IMPORT_LINKED: 'Linked (existing)',
    GHL_IMPORT_UPDATED: 'Updated',
    GHL_IMPORT_SKIPPED: 'Skipped',
    GHL_IMPORT_ERRORS: 'Errors',
    GHL_IMPORT_COMPLETED: 'Import completed successfully!',
    GHL_IMPORT_FAILED: 'Import failed',
    GHL_IMPORT_ALREADY_RUNNING: 'An import is already in progress',
    GHL_IMPORT_BACKGROUND_NOTE: 'You can leave this page. The import continues in the background.',

    // --- Shipments ---
    SHIPMENTS_LIST: 'Shipments List',
    SHIPMENT: 'Shipment',
    SHIPMENT_STATUS_PENDING: 'Pending',
    SHIPMENT_STATUS_SHIPPED: 'Shipped',
    SHIPMENT_STATUS: 'Status',
    SHIPMENT_CREATED_AT: 'Created on',
    SHIPMENT_STATUS_DRAFT: 'Draft',
    SHIPMENT_STATUS_ESTIMATED: 'Estimated',
    SHIPMENT_STATUS_CREATED: 'Created',
    SHIPMENT_STATUS_PICKUP_CREATED: 'Pickup created',
    SHIPMENT_STATUS_IN_TRANSIT: 'In transit',
    SHIPMENT_STATUS_DELIVERED: 'Delivered',
    SHIPMENT_STATUS_EXCEPTION: 'Exception',
    SHIPMENT_STATUS_CANCELLED: 'Cancelled',
    SHIPMENTS: 'Shipments',
    NEW_SHIPMENT: 'New shipment',
    NO_SHIPMENTS: 'No shipments found.',
    SHIPMENT_NAME: 'Shipment name',
    ESTIMATE_SHIPMENT: 'Estimate shipment',
    REDO_ESTIMATION: 'Redo estimation',
    ESTIMATION_CREATED: 'Estimation created',
    ESTIMATION_UPDATED: 'Estimation updated',
    ESTIMATION_DELETED: 'Estimation deleted',
    CONFIRM_DELETE_ESTIMATION: 'Delete this estimation?',
    CONFIRM_SHIPMENT: 'Confirm shipment',
    SHIPMENT_CONFIRMED: 'Shipment confirmed',
    CONFIRM_CANCEL_SHIPMENT: 'Cancel this shipment?',
    SHIPMENT_CANCELLED: 'Shipment cancelled',
    CONFIRM_DELETE_SHIPMENT: 'Delete this cancelled shipment? This action cannot be undone.',
    SHIPMENT_DELETED: 'Shipment deleted',
    LABEL_REMINDER_BEFORE_PICKUP: 'No shipping label has been generated yet. The label will no longer be available after creating the pickup.',
    PRINT_LABEL_FIRST: 'Generate a label',
    CONTINUE_WITHOUT_LABEL: 'Continue without label',
    AVAILABLE_RATES: 'Available rates',
    SELECT_SERVICE: 'Select a service',
    GENERAL_INFORMATION: 'General information',
    SENDER: 'Sender',
    RECIPIENT: 'Recipient',
    COMPANY_NAME: 'Company name',
    CONTACT_NAME: 'Contact name',
    ATTENTION_TO: 'Attention to',
    PROVINCE: 'Province / State',
    POSTAL_CODE: 'Postal code',
    PACKAGING_TYPE: 'Packaging type',
    WEIGHT_UNIT: 'Weight unit',
    PAYMENT_TYPE: 'Payment type',
    PACKAGE_DETAILS: 'Package details',
    DECLARED_VALUE: 'Declared value',
    PACKAGE: 'Package',
    PACKAGES: 'packages',
    ADD_PACKAGE: 'Add a package',
    LENGTH: 'Length',
    WIDTH: 'Width',
    HEIGHT: 'Height',
    WEIGHT: 'Weight',
    QUANTITY: 'Quantity',
    PRINT_LABEL: 'Print label',
    PICKUP_DETAILS: 'Pickup details',
    PICKUP_DATE: 'Pickup date',
    READY_AT: 'Ready at',
    READY_UNTIL: 'Ready until',
    TOTAL_WEIGHT: 'Total weight',
    PACKAGE_COUNT: 'Number of packages',
    PICKUP_LOCATION: 'Pickup location',
    INSTRUCTIONS: 'Instructions',
    CREATE_PICKUP: 'Create pickup',
    CANCEL_PICKUP: 'Cancel pickup',
    PICKUP_CREATED: 'Pickup created',
    CONFIRM_CANCEL_PICKUP: 'Cancel this pickup?',
    PICKUP_CANCELLED: 'Pickup cancelled',
    PACKAGING_PACKAGE: 'Package',
    PACKAGING_ENVELOPE: 'Envelope',
    PACKAGING_COURIER_PACK: 'Express Package',
    PACKAGING_FREIGHT: 'Freight',
    WEIGHT_LB: 'Pounds',
    WEIGHT_KG: 'Kilograms',
    LABEL_EIGHT_FIVE_BY_ELEVEN: '8.5 x 11',
    LABEL_FOUR_BY_SIX: '4 x 6',
    // Direct value keys for dynamic lookup
    Sender: 'Sender',
    ThirdParty: 'Third Party',
    package: 'Package',
    envelope: 'Envelope',
    'courier-pack': 'Express Package',
    freight: 'Freight',
    kg: 'Kilograms',
    lb: 'Pounds',
    EightFiveByEleven: '8.5 x 11',
    FourBySix: '4 x 6',

    // Pickup locations
    PICKUP_OUTSIDE_DOOR: 'Outside Door',
    PICKUP_FRONT_PORCH: 'Porch',
    PICKUP_OFFICE: 'Office',
    PICKUP_SIDE_DOOR: 'Side Door',
    PICKUP_BASEMENT: 'Basement',
    PICKUP_FRONT_DESK: 'Reception',
    PICKUP_BETWEEN_DOORS: 'Between Doors',
    PICKUP_SECURITY: 'Security',
    PICKUP_COUNTER: 'Counter',
    PICKUP_LOBBY: 'Lobby',
    PICKUP_MAILBOX: 'Mailbox',
    PICKUP_GATE_HOUSE: 'Gatehouse',
    PICKUP_DESK: 'Office',
    PICKUP_KIOSK: 'Kiosk',
    PICKUP_SHIPPING: 'Shipping',
    PICKUP_PRO_SHOP: 'Pro Shop',
    PICKUP_FRONT_DOOR: 'Front Door',
    PICKUP_RECEIVING: 'Reception',
    PICKUP_RECEPTION: 'Reception',
    PICKUP_BACK_DOOR: 'Back Door',
    PICKUP_LAB: 'Laboratory',
    PICKUP_MAIL_ROOM: 'Mailroom',
    PICKUP_GARAGE: 'Garage',
    PICKUP_PHARMACY: 'Pharmacy',
    PICKUP_SERVICE_COUNTER: 'Service Counter',
    PICKUP_PARTS_DEPARTMENT: 'Parts Department',

    // --- E-sign / Signatures ---
    ESIGNS_LIST: 'Package List',
    ADD_ESIGN: 'Create a new package',
    ESIGNS: 'Packages',
    ESIGN_ADDED: 'Package Added',
    EDIT_ESIGN: 'Edit Package',
    ESIGN_UPDATED: 'Package Updated',
    DELETE_THIS_ESIGN: 'Delete this package?',
    ESIGN_DELETED: 'Package Deleted',
    ESIGN_TYPE: 'Package Type',
    VIEW_ESIGN: 'E-sign',
    PROPERTIES: 'Properties',
    WITHOUT_ADDRESS: 'Do not enter an address',
    RETURN_TO_FORM: 'Return to Form',
    DRAFT: 'Draft',
    SENT: 'Sent',
    SENTS: 'Sent',
    COMPLETED: 'Completed',
    DECLINED: 'Declined',
    EXPIRED: 'Expired',
    CREATED: 'Created',
    UPDATED: 'Updated',
    DELETED: 'Deleted',
    EMAIL_MESSAGE: 'Message to all recipients (optional)',
    EDIT_TRANSACTION: 'Manage',
    EDITOR: 'Editor',
    CANNOT_EDIT: 'Unable to edit this package',
    CANNOT_DELETE: 'Unable to delete this package',
    CALL_BACK_URL: 'Callback URL',

    // --- Signature Templates ---
    MODELS: 'Templates',
    MODELS_LIST: 'List of templates',
    ADD_MODEL: 'Add a template',
    MODELS_ADDED: 'Added template',
    EDIT_MODEL: 'Edit a template',
    MODELS_UPDATED: 'Updated template',
    DELETE_THIS_MODEL: 'Delete this template?',
    MODELS_DELETED: 'Deleted template',
    MODELS_TYPE: 'Template category',
    CATEGORY: 'Category',
    VIEW_MODEL: 'Template',
    SAME_MODELS: 'One or more models have already been registered with the name {name}. Are they the same template? Click "Continue" to save if this is the case, otherwise click "Cancel".',
    SELECT: 'Select a template',
    DPA: 'Pre-authorized Debit and Credit',
    PPA: 'Pre-authorized Payment',
    OTHERS: 'Others',
    WHOLESALE_DEALER: 'Wholesale Membership Template',
    DEALER: 'Dealer Membership Template',
    TYPE_REQUIRED: 'Please select a category',
    MODEL_DOCUMENTS: 'Template Documents',
    REPLACE_WITH: 'Replace with',
    DOCUMENT_NAME: 'Document Name',
    YOU_CAN_CHANGE_DOCUMENTS: 'You can replace the original documents with new files. The initial signature fields will be preserved.',
    SELECT_A_FILE: 'Select a file',

    // --- Documents ---
    FILES: 'Documents',
    FILES_TO_BE_SIGN: 'Documents to be signed',
    SIGNED_FILES: 'Signed documents',
    ADD_FILE: 'Add Document',
    ADD_FILES: 'Add Documents',
    DELETE_THIS_FILE: 'Delete this document?',
    FILE_DELETED: 'Document deleted!',
    NAME_REQUIRED: 'Please enter the document name',
    SIGNATURE_PAGE: 'Signature Page',
    SIGNATURE_PAGE_REQUIRED: 'Signature page number is required',
    SIGNATURE_TYPE: 'Signature type',
    NO_SIGNATURES: 'No signature',
    SIGNATURE_TYPE_REQUIRED: 'Signature type is required',
    EDIT_FILE: 'Edit document',
    ADD_TEMPLATE_DOCUMENT: 'Add document template',
    TEMPLATE_NAME: 'Template (view)',
    TEMPLATE_NAME_REQUIRED: 'Template name is required',
    FILTER_MODELS: 'Filter templates',
    UNDETERMINED: 'Template undetermined?',
    DURATION: 'Duration in months',
    MODEL_REQUIRED: 'Please select a template!',

    // --- Signature Fields ---
    FULLNAME: 'First and last name',
    INITIALS: 'Initials',
    CAPTURE: 'Signature capture',
    LABEL: 'Label',
    TEXTFIELD: 'Short Text field',
    TEXTAREA: 'Text Box',
    CHECKBOX: 'Checkbox',
    RADIO: 'Radio Buttons',
    LIST: 'Drop-Down List',
    QRCODE: 'QR Code',
    CUSTOMFIELD: 'Custom Field',
    SEAL: 'Attachment',
    MOBILE_CAPTURE: 'Mobile Capture',
    RAW_CAPTURE: 'Raw Capture',
    DATEPICKER: 'Date Picker',
    DPA_CREDIT: 'Direct Deposit',
    DPA_DEBIT: 'Pre-Authorized Debit',

    // --- Signature Pages ---
    SIGNATURE_PAGES: 'Signature Pages',
    SIGNATURE_PAGES_REQUIRED: 'You must add at least one signature page',
    SIGNATURE_POSITION_PAGE_NUMBER: 'Number',
    SIGNATURE_POSITION_PAGE_NUMBER_REQUIRED: 'Number is required',
    SIGNATURE_POSITION_X: 'X',
    SIGNATURE_POSITION_Y: 'Y',
    SIGNATURE_POSITION_WIDTH: 'Width',
    SIGNATURE_POSITION_HEIGHT: 'Height',
    ADD_SIGNATURE_PAGE: 'Add a page',

    // --- Signatures ---
    SIGNATURES: 'Signatures',
    SIGNATURE: 'Signature',
    SIGNATURES_LIST: 'List of signatures',
    ADD_SIGNATURE: 'Add a signature',
    SIGNATURE_ADDED: 'Added signature',
    EDIT_SIGNATURE: 'Edit a signature',
    SIGNATURE_UPDATED: 'Updated signature',
    DELETE_THIS_SIGNATURE: 'Delete this signature?',
    SIGNATURE_DELETED: 'Deleted signature',
    VIEW_SIGNATURE: 'Signature',
    SAME_SIGNATURES: 'One or more signatures have already been saved with the name "{name}". Is this the same signature?',
    MODELS_REQUIRED: 'Please select a model',
    SELECT_MODEL: 'Select a model',

    // --- Signers ---
    SIGNERS: 'Signers',
    SIGNERS_REQUIRED: 'Please add at least one signer',
    ADD_SIGNER: 'Add Signatory',
    SEND: 'Send',
    RESEND: 'Resend',
    SEND_FOR_SIGN_MESSAGE: 'Do you confirm that you want to send this request to the various signers?',
    SIGNATURE_SENT: 'Signature request sent!',
    SIGNATURE_NOT_SENT: 'Failed to send signature, please complete the required information',
    SIGNERS_EMAIL_MESSAGE: 'A message to accompany the signature email?',
    EMAIL_MESSAGE_TITLE: 'Signature Email',
    RESEND_SIGNATURE_EMAIL: 'Resend Signature Email',
    VIEW_DETAILS: 'More Details',
    GET_DOCUMENTS: 'Upload Signed Documents',
    DOCUMENTS_CHARGED: 'Documents successfully uploaded!',
    FROM_MODEL: 'From a template',
    FROM_TEMPLATE: 'From a template',
    ROLES: 'Roles of the different signers',
    ADD_ROLES: 'Enter to add roles',
    ROLES_REQUIRED: 'Please add the different roles',
    SEND_FOR_SIGNATURE: 'Send immediately for signature',
    DOCUMENT: 'Document',
    ROLE: 'Role',
    DOCUMENTS_PAYLOAD: 'Fields to fill out for documents',
    CLONE_MODEL: 'Clone a model',

    // --- Form fields ---
    FIRSTNAME: 'First Name',
    LASTNAME: 'Last Name',
    PASSWORD: 'Password',
    ADDRESS: 'Address',
    PHONE: 'Phone',
    COUNTRY: 'Country',
    COUNTRIES: 'Countries',
    STATES: 'States',
    STATE: 'State',
    CITY: 'City',
    ZIPCODE: 'Zip Code',
    NOTE: 'Note',
    AMOUNT: 'Amount',
    TITLE: 'Title',
    CODE: 'Code',
    COLOR: 'Color',
    EXCERPT: 'Description',
    PICTURE: 'Picture',
    UNIT_PRICE: 'Unit price',
    SUBTOTAL: 'Subtotal',
    PRICE: 'Price',
    RATE: 'Rate (%)',
    TAXES: 'Taxes',
    PAYMENTS: 'Payments',
    USERS: 'Users',
    USER: 'User',
    OWNER: 'Owner',
    EMAILS: 'Emails',
    EMAILS_CC: 'Cc',
    EMAILS_CCI: 'Bcc',
    TEMPLATES_MAILS: 'Email templates',
    GLOBAL: 'Global.',
    NUMBER: 'No.',

    // --- Validation ---
    EMAIL_REQUIRED: 'Email address is required',
    EMAIL_INCORRECT: 'Invalid email address',
    FIRSTNAME_REQUIRED: 'First name is required',
    LASTNAME_REQUIRED: 'Last name is required',
    ROLE_MUST_BE_UNIQUE: 'Role must be unique',
    NO_SIGNERS: 'No signers assigned.',
    SIGNER_STATUS_SIGNED: 'Signed',
    SIGNER_STATUS_PENDING: 'Pending',
    SIGNER_STATUS_DECLINED: 'Declined',
    SENT_AT: 'Sent at',
    COMPLETED_AT: 'Completed at',
    SIGNATURE_NOT_FOUND: 'Signature not found.',
    SHOW_TEMPLATES_FIELDS_CODES: 'Show template fields codes',
    COPY: 'Copy',
    FIELDS_CODES: 'Fields Codes',
    NO_FIELD_FOUND: 'No field found',
    SEARCH_FIELD: 'Search a field...',
    START_TYPING_CITY_REGION_COUNTRY: 'Start by entering the city, region, or country to complete the address.',
    FIELD_REQUIRED: 'This field is required',
    ROLE_REQUIRED: 'Role is required',
    FOR_SIGNATURE: 'for signature',

    // --- Mail Templates ---
    MT_MAIL_TEMPLATE: 'Mail Template',
    MT_MAIL_TYPE: 'Mail Type',
    MT_SELECT_TYPE: 'Select a mail type',
    MT_TYPE_REQUIRED: 'Please select a mail type',
    MT_SUBJECT: 'Subject',
    MT_SECTIONS: 'Sections',
    MT_ADD_SECTION: 'Add a section',
    MT_FROM_EMAIL: 'From (email)',
    MT_FROM_NAME: 'From (name)',
    MT_REPLY_TO: 'Reply to',
    MT_RECIPIENTS: 'Recipients',
    MT_IS_DEFAULT: 'Default template',
    MT_STYLING: 'Styling',
    MT_BACKGROUND_COLOR: 'Background color',
    MT_TITLE_STYLE: 'Title style',
    MT_TEXT_STYLE: 'Text style',
    MT_LINKS_STYLE: 'Links style',
    MT_FOOTER_STYLE: 'Footer style',
    MT_BUTTONS_COLORS: 'Button colors',
    MT_FONT_FAMILY: 'Font',
    MT_FONT_SIZE: 'Size',
    MT_VARIABLES: 'Available variables',
    MT_PREVIEW: 'Preview',
    MT_PREVIEW_HINT: 'Click "Preview" to generate the email preview.',
    MT_ADD: 'Add mail template',
    MT_EDIT: 'Edit mail template',
    MT_CREATE: 'Create',
    MT_UPDATE: 'Update',
    MT_CREATED: 'Mail template created',
    MT_UPDATED: 'Mail template updated',
    MT_DELETED: 'Mail template deleted',
    MT_CONFIRM_DELETE: 'Delete this mail template?',
    MT_NO_TEMPLATES: 'No mail templates found.',
    MT_NOT_FOUND: 'Mail template not found.',
    MT_DEFAULT: 'Default',
    MT_TEMPLATE_DETAILS: 'Template details',
    MT_REFRESH_PREVIEW: 'Refresh preview',
  },

  // ── Mail V2 ─────────────────────────────────────────────────────
  MV2: {
    TEMPLATES_LIST: 'Templates list',
    MAIL_SETTINGS: 'Mail settings',
    ALL_CATEGORIES: 'All categories',
    ALL_STATUS: 'All statuses',
    TRANSACTIONAL: 'Transactional',
    NOTIFICATION: 'Notification',
    MARKETING: 'Marketing',
    CUSTOMIZED: 'Customized',
    USING_DEFAULT: 'Default',
    CUSTOMIZE: 'Customize',
    CUSTOMIZE_CONFIRM: 'Customize the "{name}" template? A copy will be created for your organization.',
    CUSTOMIZE_ERROR: 'Error customizing the template.',
    TEMPLATE_CUSTOMIZED: 'Template customized successfully.',
    RESET_DEFAULT: 'Reset to default',
    RESET_CONFIRM: 'Reset to default template? Your customizations will be lost.',
    RESET_ERROR: 'Error resetting template.',
    TEMPLATE_RESET: 'Template reset to default.',
    EDIT_TEMPLATE: 'Edit template',
    TEMPLATE_SAVED: 'Template saved successfully.',
    SAVE_ERROR: 'Error saving.',
    NO_TEMPLATES: 'No templates found.',
    SUBJECT: 'Subject',
    SUBJECT_PLACEHOLDER: 'Email subject...',
    FROM_NAME: 'Sender name',
    FROM_EMAIL: 'Sender email',
    REPLY_TO: 'Reply-to email',
    REPLY_TO_NAME: 'Reply-to name',
    REPLY_TO_EMAIL: 'Reply-to email',
    VARIABLES: 'Variables',
    CLICK_TO_INSERT: 'Click to insert',
    COPY_FROM: 'Copy from',
    COPY_LABEL: 'Copy {from} \u2192 {to}',
    SENDER_OVERRIDE: 'Sender',
    SEND_TEST: 'Send test',
    TEST_EMAIL_PLACEHOLDER: 'address@test.com',
    SEND: 'Send',
    TEST_SENT: 'Test email sent.',
    TEST_ERROR: 'Error sending test.',
    TYPE_SETTINGS: 'Type settings',
    CODE: 'Code',
    CATEGORY: 'Category',
    REFRESH: 'Refresh',
    PREVIEW_HINT: 'Select a template to display the preview.',
    // Settings
    SENDER_DEFAULTS: 'Default sender',
    DEFAULT_LOCALE: 'Default language',
    BRANDING: 'Branding',
    LOGO_URL: 'Logo URL',
    LOGO_HEIGHT: 'Logo height (px)',
    PRIMARY_COLOR: 'Primary color',
    SECONDARY_COLOR: 'Secondary color',
    FOOTER: 'Footer',
    FOOTER_TEXT: 'Footer text',
    UNSUBSCRIBE_URL: 'Unsubscribe URL',
    SETTINGS_SAVED: 'Settings saved.',
    // Admin
    LAYOUTS: 'Layouts',
    LAYOUT_NAME: 'Layout name',
    LAYOUT_SAVED: 'Layout saved.',
    TYPES_LIST: 'Mail types',
    DEFAULT_TEMPLATE: 'Default template',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    SELECT_TEMPLATE: 'Select a mail template...',
  },
}
